import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { MDBModalRef } from 'angular-bootstrap-md';

@Component({
  selector: 'app-success-dialog',
  templateUrl: './success-dialog.component.html',
  styleUrls: ['./success-dialog.component.scss']
})
export class SuccessDialogComponent implements OnInit {
  action = new Subject();
  message: string = '';
  data: any[] = [];
   warnings: any[] = [];
  constructor(public modalRef: MDBModalRef) { }

  ngOnInit() {
    console.log(this.message);
     console.log(this.warnings);
  }
  close() {
    this.action.next('OK');
    //this.modalRef.hide();
  }

}
